import * as echarts from "echarts";

const geo = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        adcode: 440300,
        name: "Shenzhen",
        level: "city"
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [113.75, 22.45],
            [114.65, 22.45],
            [114.65, 22.95],
            [113.75, 22.95],
            [113.75, 22.45]
          ]
        ]
      }
    }
  ]
};

echarts.registerMap("fujian", geo);
echarts.registerMap("shenzhen", geo);
echarts.registerMap("sz", geo);

export default geo;
